import React from "react";

import styled from "styled-components";

import { getServiceSmsPrefix } from "utils";
import CustomField from "components/Form/CustomField";
import NumberField from "components/Form/NumberField";
import Form from "components/Form/CompatForm";
import SDE from "components/Filters/SDE";

import { Schema, SelectPicker } from "rsuite";

const { NumberType } = Schema.Types;

// const numbers = ["1000", "10000", "100000", "1000000"].map(x => ({label: x, value: +x}));
const numbers = ["1000"].map(x => ({ label: x, value: +x }));

const formModel = Schema.Model({
    sde_key: NumberType().isRequired("Required"),
    ranges: NumberType()
        .isRequired("Required")
        .isInteger("Only whole numbers")
        .max(100, "The maximum of this field is 100"),
});


export default React.forwardRef(({ sde_key, service }, ref) => {
    const method = getServiceSmsPrefix(service, "price_range__generate_by_sde");

    return (
        <Form
            layout="inline"
            ref={ref}
            formDefaultValue={{
                numbers: 1000,
                ranges: 1,
                sde_key
            }}
            model={formModel}
            method={method}
        >
            <RandomFieldsRow>
                <SdeWrapper>
                    <SDE
                        name="sde_key"
                        validationKey="num_required"
                        classPrefix={undefined}
                    />
                </SdeWrapper>

                <RangesFieldWrapper>
                    <NumberField
                        label="Number of ranges"
                        name="ranges"
                        placeholder="0"
                        min={1}
                        max={Infinity}
                        step={1}
                    />
                </RangesFieldWrapper>
            </RandomFieldsRow>

            <CustomField
                accepter={SelectPicker}
                data={numbers}
                label="Number per range"
                name="numbers"
                cleanable={false}
                searchable={false}
            />

        </Form>
    );
});

const RandomFieldsRow = styled.div`
    display: flex;
    flex-wrap: wrap;
    gap: 12px 20px;
    margin-right: 0 !important;
    max-width: 100%;
    width: 100%;
`;

const RangesFieldWrapper = styled.div`
    flex: 0 0 300px;
    max-width: 100%;
    min-width: 0;

    .rs-form-group {
        margin-right: 0;
        white-space: nowrap;
    }
`;

const SdeWrapper = styled.div`
    flex: 0 1 240px;
    max-width: 100%;
    min-width: 0;
    width: 240px;

    &&&& {
        display: block;

        .rs-form-group,
        .rs-form-control-wrapper,
        .rs-picker,
        .rs-picker-toggle-wrapper {
            margin-left: 0;
            max-width: 100%;
            width: 100%;
        }
    }
`;
